import {
  architect
} from 'neataptic'

export default function(data) {

  let lastT = parseInt(data[data.length - 1][0]);
  let lastY = data[data.length - 1][1];

  let trainingXgenerator = (t, h) => {
    let dt = new Date(parseInt(t));
    return [dt.getDate() / 31, dt.getDay() / 7, dt.getHours() / 24];
  };

  let trainingYgenerator = (t, h) => [h[t]];

  let transformedData = transform(data);
  //console.log('TRANSFORM', transformedData);

  let histogram = deaccumulatedArray(transformedData);
  //console.log('HISTOGRAM', histogram);

  let trainingData = makeTrainingData(trainingXgenerator, trainingYgenerator, histogram);
  //console.log('TRAINING', trainingData);

  if (trainingData.keys.length == 0) return null;

  let network = new architect.LSTM(3, 8, 1);

  network.train(trainingData.data, {
    iterations: 1000,
    error: 0.003,
    clear: true,
    rate: 0.1,
  });

  let validationY = trainingData.data.map(d => network.activate(d.input));
  accumulatedArray(validationY);
  validationY = validationY.map((v, i) => ({
    t: parseInt(trainingData.keys[i]),
    y: v[0]
  }));
  //console.log('VALIDATION Y', validationY);


  let predictX = [];
  let pKeys = [];
  for (let i = 0; i < 24; i++) {
    let t = lastT + (i + 1) * 3600000;
    pKeys.push(t);
    predictX.push(trainingXgenerator(t, histogram));
  }
  let predictY = predictX.map(d => network.activate(d));
  accumulatedArray(predictY);
  predictY = predictY.map((v, i) => ({
    t: pKeys[i],
    y: lastY + v[0]
  }));


  return {
    validationY: validationY,
    predictY: predictY
  };
}

function transform(rawData) {
  if (!rawData) return null;
  let result = rawData.map(r => ({
    '_id': r[0],
    'kwh': r[1]
  }));
  result.reduceRight((last, curr, i) => {
    if (result.length - 1 == i) return curr.kwh;
    if (last < curr.kwh) {
      result[i].kwh = 0;
      return last
    }
    return curr.kwh
  }, 0);
  return result.filter((r, i) => {
    return r.kwh > 0 && (i > 0 && r.kwh >= result[i - 1].kwh)
  }).reduce((obj, item) => {
    obj[item._id] = item.kwh;
    return obj;
  }, {});
}

function makeTrainingData(trainingXgenerator, trainingYgenerator, histogram) {
  let tKeys = Object.keys(histogram).sort();
  return {
    keys: tKeys,
    data: tKeys.map(t => ({
      input: trainingXgenerator(t, histogram),
      output: trainingYgenerator(t, histogram)
    }))
  };
}

function accumulatedArray(arr) {
  arr.reduce((prev, curr, i) => {
    if (prev) {
      let acc = curr.map((c, j) => curr[j] + prev[j]);
      arr[i] = acc;
      return acc;
    }
    return curr;
  }, false);
}

function deaccumulatedArray(accu) {
  let deaccu = {};
  let lastKey;
  Object.keys(accu).sort()
    .reduceRight((ts, t) => {
      if (ts) deaccu[ts] = accu[ts] - accu[t];
      lastKey = t;
      return t;
    }, 0);
  return deaccu;
}



// WEBPACK FOOTER //
// ./src/components/utils/MeterLSTM.js